import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "RECIPIENT/REQUEST_CONSENT"

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },
        setSelectAllOrSelectSelectedModal: (state, action) => {
            state.selectAllOrSelectSelectedModal = action.payload;
        },
        setNoOfConsentRequestInfoModal: (state, action) => {
            state.noOfConsentRequestInfoModal = action.payload;
        },
        setConsentRequestPaymentDrawer: (state, action) => {
            state.consentRequestPaymentDrawer = action.payload;
        },
        setConsentRequestCountDetails: (state, action) => {
            state.consentRequestCountDetails = action.payload;
        },
        setConsentRequestFeesDetails: (state, action) => {
            state.consentRequestFeesDetails = action.payload;
        },
        setIsSelectAll: (state, action) => {
            state.isSelectAll = action.payload;
        },
        setZeroRequestMessageModal: (state, action) => {
            state.zeroRequestMessageModal = action.payload;
        }
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.LOADING, message: "" },
        consentRequestCountDetails: {},
        consentRequestFeesDetails: {},
        isSelectAll: false,

        // Modals
        selectAllOrSelectSelectedModal: false,
        noOfConsentRequestInfoModal: false,
        consentRequestPaymentDrawer: false,
        zeroRequestMessageModal: false,
    }
});

export const { setLoadingState, setSelectAllOrSelectSelectedModal, setNoOfConsentRequestInfoModal, setConsentRequestPaymentDrawer, setConsentRequestCountDetails, setConsentRequestFeesDetails, setIsSelectAll, setZeroRequestMessageModal } = actions;
